import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import Select from "./elements/Select"

export default function SortSelect() {
    const { activeSort, setSort } = useSort(sortOptions)
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    return (
        <div class="ns-sort-select-wrap ns-flex ns-flex-nowrap ns-items-center">
            <Select
                value={activeSort}
                onChange={e => handleSortChange(e)}
                className="ns-sort-select ns-text-right"
                options={options}
                label={"Sort by"}
                disabled={"Sort By"}
            />
            <svg aria-hidden="true" role="presentation" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0.5C0 0.5 2.87324 5.5 2.95775 5.5C3.12676 5.5 6 0.5 6 0.5H0Z" fill="black"/>
            </svg>
        </div>
    )
}